import { MdrCompaniesGridDataProvider } from '../dataProvider/MdrCompaniesGridDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';

export class MdrCompaniesGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_GZ, MdrCompaniesGridDataProvider);
  }
}
